import { ReactNode } from "react";
import { imgHomeMenuTablet } from "@/shared/assets/img";

type Props = {
  children: ReactNode;
};

export default function TabletWrapper({ children }: Props) {
  return (
    <div
      id="tablet"
      className="relative flex justify-center items-center w-[68.75rem] h-[45.625rem] rounded-4 overflow-hidden"
      style={{
        backgroundImage: `url(${imgHomeMenuTablet})`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
      }}
    >
      {children}
    </div>
  );
}
